/* eslint-disable react/prop-types */
import { Box, IconButton, InputAdornment } from "@mui/material";
import React, { useContext, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import * as Sentry from "@sentry/react";
import Button from "../../../../components/common/Button";
import Typography from "../../../../components/common/new/Typography/Typography";
import { CommonStyles } from "../../../../components/common/Button/commonButtonStyle";
import { ToastAlertContext } from "../../../../config/providers/ToastAlert";
import { AlertStatus } from "../../../../contants";
import InputField from "../../../../components/common/new/InputField/InputField";
import User from "../../../../services/api/user";

function PasswordResetModal({ selectedMember, onClose, callBack }) {
  const { memberId, fullName } = selectedMember;
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const toast = useContext(ToastAlertContext);

  const formValidation = () => {
    if (newPassword.length < 6) {
      return "Please enter at least 6 characters";
    }
    if (confirmPassword !== newPassword) {
      return "Confirm password does not match New password";
    }
    return null;
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    try {
      const error = formValidation();
      if (error) throw new Error(error);
      await User.resetPassword({ newPassword, memberId });
      toast.show("Password Updated Successfully", AlertStatus.SUCCESS);

      setTimeout(() => {
        onClose();
        callBack();
      }, 2000);
    } catch (error) {
      Sentry.captureException(error);
      toast.show(
        error.message || "Something went wrong. Please contact support.",
        AlertStatus.ERROR
      );
    }
  };

  return (
    <form onSubmit={onSubmit}>
      {/* {({ values, errors, handleChange, handleSubmit }) => ( */}
      <Box style={{ display: "flex" }}>
        <Typography variant="title2" color="#8c8c8c">
          Reset Password
        </Typography>

        <div
          style={{
            position: "relative",
            float: "right",
            top: "-8px",
            marginLeft: "auto",
          }}
        >
          <IconButton>
            <CloseIcon onClick={onClose} />
          </IconButton>
        </div>
      </Box>
      <Box>
        <Typography variant="small" fontWeight={500}>
          Passsword must contain at least six characters.
        </Typography>
      </Box>
      <Box mt={4}>
        <InputField label="Member ID" disabled value={memberId} />
      </Box>
      <Box mt={2}>
        <InputField label="Member Name" disabled value={fullName} />
      </Box>
      <Box>
        <Box mt={2}>
          <InputField
            required
            label="New Password"
            type={showPassword ? "text" : "password"}
            name="newPassword"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            // error={errors[RESET_PASSWORD_FIELDS.NEW_PASSWORD]}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={() => setShowPassword(!showPassword)}>
                    {showPassword ? (
                      <VisibilityOutlinedIcon />
                    ) : (
                      <VisibilityOffOutlinedIcon />
                    )}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Box>
        <Box mt={2}>
          <InputField
            required
            label="Confirm Password"
            type={showConfirmPassword ? "text" : "password"}
            onChange={(e) => setConfirmPassword(e.target.value)}
            value={confirmPassword}
            // error={errors[RESET_PASSWORD_FIELDS.CONFIRM_PASSWORD]}
            name="confirmPassword"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  >
                    {showConfirmPassword ? (
                      <VisibilityOutlinedIcon />
                    ) : (
                      <VisibilityOffOutlinedIcon />
                    )}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Box>
      </Box>
      <Box
        style={{
          color: "#8C8C8C",
          textAlign: "right",
          marginTop: "8px",
        }}
      >
        {/* <VisibilityOffOutlinedIcon /> */}
      </Box>
      <Box style={{ display: "flex", gap: 16 }}>
        <Button
          style={CommonStyles.buttonStyle}
          variant="contained"
          type="submit"
          label="SAVE"
          // onClick={handleSubmit}
        />
        <Button
          style={CommonStyles.buttonStyle}
          variant="outlined"
          onClick={onClose}
          label="CANCEL"
        />
      </Box>
      {/* )} */}
    </form>
  );
}

export default PasswordResetModal;
